/* eslint-disable @nx/enforce-module-boundaries */
import { ColDef, GridOptions } from '@ag-grid-community/core';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { FilterConfig, FilterFormValueInterface } from '@ellf/app-common';
import { FilterValue } from '@ellf/common-interfaces';
import { FormGroupState } from 'ngrx-forms';
import { Observable } from 'rxjs';
import { DataGridAction } from '../grid/data-grid/data-grid-action';
import { EntityListAction } from './entity-list-action';

@Component({
    selector: 'ellf-entity-list',
    templateUrl: './entity-list.component.html',
    styleUrls: ['./entity-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EntityListComponent {
  @Input()
  filterFormState$!: Observable<FormGroupState<FilterFormValueInterface>>;

  @Input()
  filters!: FilterConfig[];

  @Input()
  gridOptions!: GridOptions;

  @Input()
  customActions: DataGridAction[] = [];

  @Input()
  items: any[] = [];

  @Input()
  columnDefs!: ColDef[];

  @Input()
  currentPage!: number;

  @Input()
  pageSize!: number;

  @Input()
  totalRows!: number;

  @Input()
  canEdit? = false;

  @Input()
  editVisible?: (i: any) => boolean;

  @Input()
  deleteVisible?: (i: any) => boolean;

  @Input()
  viewVisible?: (i: any) => boolean;

  @Input()
  canView? = false;

  @Input()
  canDelete? = false;

  @Input()
  canSelect? = false;

  @Input()
  canDownloadExcel? = false;

  @Input()
  canDownloadPdf? = false;

  @Input()
  fileName = '';

  @Input()
  title = '';

  @Input()
  paged = true;

  @Input()
  gridActions: EntityListAction[] = [];

  isMinimized = true;

  @Output()
  view = new EventEmitter<any>();

  @Output()
  edit = new EventEmitter<any>();

  @Output()
  delete = new EventEmitter<any>();

  @Output()
  filterChanged: EventEmitter<FilterValue[]> = new EventEmitter<
    FilterValue[]
  >();

  @Output()
  pageChanged: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  pageSizeChanged: EventEmitter<number> = new EventEmitter<number>();

  @Output()
  excel: EventEmitter<string> = new EventEmitter();

  @Output()
  pdf: EventEmitter<string> = new EventEmitter();

  pageSizeControl = new UntypedFormControl();

  get firstRecord() {
    return (this.currentPage - 1) * this.pageSize + 1;
  }

  get lastRecord() {
    const max = (this.currentPage - 1) * this.pageSize + this.pageSize;
    if (this.totalRows < max) return this.totalRows;
    return max;
  }

  filter(filters: FilterValue[]) {
    this.filterChanged.emit(filters);
  }
  onPageChange(newPage: number) {
    this.pageChanged.emit(newPage);
  }
  downloadExcel() {
    this.excel.emit(this.fileName);
  }
  downloadPdf() {
    this.pdf.emit(this.fileName);
  }

  minimize() {
    this.isMinimized = true;
  }

  maximize() {
    this.isMinimized = false;
  }
}
